import { useContext } from 'react';

import { QContentDetailsModalContext } from './qcontent-details-modal-provider';

function useQContentDetailsModal() {
  const context = useContext(QContentDetailsModalContext);

  if (!context) {
    throw new Error('useQContentDetailsModal must be used within a QContentDetailsModalProvider');
  }

  return context;
}

export { useQContentDetailsModal };
